import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
import ResultStep from './ResultStep/ResultStep';
import { useUpdateResultsChallenge } from '../../../hooks/useUpdateResultsChallenge';
import Swal from 'sweetalert2';

const useStyles = makeStyles((theme) => ({
  root: {
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  title: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.text.primary,
    marginBottom:25
  }
}));

const ChallengeResultSteps = ({ stepResults, challengeId, currentStep, status, blockedSteps }) => {
  const classes = useStyles();
  const updateResultsMutation = useUpdateResultsChallenge();

  const handleUpdateStep = (stepIndex, { score, isValidation, note, attachedFile } = {}) => {
    updateResultsMutation.mutate({
      challengeId,
      step: stepIndex,
      score,
      isValidation,
      note,
      attachedFile
    }, {
      onSuccess: () => {
        Swal.fire({
          type: 'success',
          title: 'Step aggiornato',
          showConfirmButton: false,
          timer: 1500
        });
      },
      onError: (error) => {
        Swal.fire({
          type: 'error',
          title: 'Errore',
          text: error?.message || 'Si è verificato un errore',
          showConfirmButton: false,
          timer: 1500
        });
        console.error('Error updating step:', error);
      }
    });
  };

  return (
    <Box>
      <Typography className={classes.title}  variant="h2">
        Steps summary
      </Typography>

      {stepResults
        .filter((step, index) => {
          // Se in validazione, mostra fino allo step corrente incluso (l'utente ha completato currentStep)
          // Se in progress, mostra solo gli step precedenti (l'utente sta facendo currentStep)
          return status === 'IN_VALIDATION' ? index <= currentStep : index < currentStep;
        })
        .map((step, index) => (
          <ResultStep
            step={step}
            stepIndex={index}
            challengeId={challengeId}
            currentStep={currentStep}
            status={status}
            blockedSteps={blockedSteps}
            onUpdateStep={handleUpdateStep}
            isUpdating={updateResultsMutation.isPending}
            key={`result-step-${index}`}
          />
        ))}
    </Box>
  );
};

export default ChallengeResultSteps;
